import { createContext } from 'react';

import { IDropzoneContext } from './Dropzone.interfaces';

export const DropzoneContext = createContext<IDropzoneContext | undefined>(undefined);
